var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _vm.requiresAuthentication
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col logo-header" },
                [
                  _c("router-link", { attrs: { to: "/" } }, [
                    _c("img", {
                      attrs: {
                        src: require("./assets/images/logo.png"),
                        width: "111px"
                      }
                    })
                  ])
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.requiresAuthentication
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col menu-slot" },
                [_c("menu-component")],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col main-content" }, [_c("router-view")], 1)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [_vm.requiresAuthentication ? _c("footer-component") : _vm._e()],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "vue-cookie",
          {
            attrs: {
              debug: false,
              position: "bottom",
              disableDecline: false,
              transitionName: "slideFromBottom"
            },
            on: {
              status: _vm.cookieStatus,
              clickedAccept: _vm.cookieClickedAccept,
              clickedDecline: _vm.cookieClickedDecline
            }
          },
          [
            _c("div", { attrs: { slot: "message" }, slot: "message" }, [
              _vm._v(
                "\n                OMyFu speichert personenbezogene Daten. Bist du damit einverstanden? "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "http://www.omyfu.com/disclaimer",
                    target: "_blank"
                  }
                },
                [_vm._v("Mehr erfahren...")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { slot: "declineContent" }, slot: "declineContent" },
              [_vm._v("\n                Ablehnen\n            ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { slot: "acceptContent" }, slot: "acceptContent" },
              [_vm._v("\n                Einverstanden\n            ")]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 